import { useCallback, useMemo } from "react";
import { isEmptyPassport, isHeld, toPassport, type Passport } from "@oshimap/domain";
import { ep, session } from "../../lib/api";
import { queryKeys } from "@oshimap/query";
import { useQuery } from "../../lib/use-query";

export function usePassport() {
  const { state, reload } = useQuery<Passport | null>(
    [...queryKeys.passport(), session.state.status],
    async (signal) => (session.state.status === "authenticated" ? toPassport(await ep.getPassport({ signal })) : null),
  );

  const derived = useMemo(() => {
    if (state.status !== "success" || !state.data) return null;
    const p = state.data;
    const held = p.stamps.filter(isHeld);
    return {
      passport: p,
      isEmpty: isEmptyPassport(p),
      heldStamps: held,
      /** 첫 스탬프까지 남은 곳 — 빈 여권이 채우고 싶게 보이는 근거 (FR-PASS-05) */
      toFirstStamp: held.length === 0 ? 1 : 0,
    };
  }, [state]);

  const refresh = useCallback(() => reload(), [reload]);
  return { state, derived, refresh };
}
